// extracted by mini-css-extract-plugin
export default {"pendingStatus":"Table_pendingStatus__Z6zA0","completedStatus":"Table_completedStatus__qZp-4","container":"Table_container__yV0xE"};